import styled, { css } from 'styled-components';
import {
  CpBody00Secondary,
  CpBody01Link,
  CpBody03Primary,
} from 'components/atoms/customer-portal/typography';
import { CpSubTaskCard as CommonSubTaskCard } from './cp-sub-task-card';

export const CpSubTaskCard = styled(CommonSubTaskCard)<{
  isLastCard?: boolean;
}>`
  ${({ isLastCard }) =>
    isLastCard
      ? css`
          border-bottom: none;
        `
      : ''};
`;
export const SectionWrapper = styled.div`
  padding: var(--cp-spacing-06) 0;
  border: 1px solid var(--cp-border-subtle);
  border-radius: var(--border-radius-small);
  @media (max-width: 768px) {
    padding: var(--cp-spacing-05) 0;
  }
`;

export const PreTitle = styled(CpBody00Secondary)`
  padding-left: var(--cp-spacing-05);
  padding-right: var(--cp-spacing-05);
  text-transform: lowercase;
  margin-bottom: var(--cp-spacing-02);
`;

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: var(--cp-spacing-05);
  padding-right: var(--cp-spacing-05);
  margin-bottom: var(--cp-spacing-07);
  @media (max-width: 768px) {
    margin-bottom: var(--cp-spacing-06);
  }
  @media (max-width: 480px) {
    margin-bottom: var(--cp-spacing-05);
  }
`;

export const SectionName = styled(CpBody03Primary)`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: start;
`;

export const ActionsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: var(--cp-spacing-05);

  @media (max-width: 480px) {
    .ant-radio-group.ant-radio-group-outline {
      display: none;
    }
  }
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  width: 32px;
  border-radius: var(--border-radius-small);
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: var(--cp-background-as-black-opacity-02);
  }

  &:active {
    background: var(--cp-background-as-black-opacity);
  }
`;

export const AddItemWrapper = styled.div<{
  withTopMargin?: boolean;
}>`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: start;
  padding-left: var(--cp-spacing-05);
  padding-right: var(--cp-spacing-05);
  transform: translateX(-4px);
  margin-top: ${(props) =>
    props.withTopMargin ? 'var(--cp-spacing-06)' : '0'};

  svg {
    fill: var(--cp-link-primary);
    margin-right: var(--cp-spacing-03);
  }

  cursor: pointer;
`;

export const AddItemButton = styled(CpBody01Link)``;

export const AddTask = styled.span``;

export const Or = styled.span`
  margin-left: var(--spacing-02);
  margin-right: var(--spacing-02);
`;

export const AddForm = styled.span``;
